import { render, staticRenderFns } from "./RevSidebar.vue?vue&type=template&id=1e167096"
import script from "./RevSidebar.vue?vue&type=script&lang=js"
export * from "./RevSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports